import type { RunStatus } from "../types";

interface HistoryRailProps {
  history: RunStatus[];
  onLoad: (runId: string) => void;
  onOpenDefinition: (runId: string) => void;
}

export function HistoryRail({ history, onLoad, onOpenDefinition }: HistoryRailProps) {
  return (
    <footer className="history-rail">
      <span className="history-title">runs</span>
      <div className="history-cards">
        {history.length === 0 && (
          <span className="history-empty">no runs yet — press Run to record one</span>
        )}
        {history.map((run) => (
          <div key={run.id} className={`history-card status-${run.status ?? "done"}`}>
            <button
              className="history-load"
              onClick={() => onLoad(run.id)}
              title="load this run's replay (re-materializes if needed)"
            >
              <span className="history-name">{run.name ?? run.id}</span>
              <span className="history-meta mono">
                seed {run.seed ?? "?"} · {run.ticks}t ·{" "}
                {run.digest ? run.digest.slice(0, 8) : (run.status ?? "done")}
              </span>
            </button>
            <button
              className="history-open"
              title="open this definition in the editor"
              onClick={() => onOpenDefinition(run.id)}
            >
              edit def
            </button>
          </div>
        ))}
      </div>
    </footer>
  );
}
